import { html } from '@inter-ikea-kompis/web-component';
export default class SummaryPageCustomTabsUtility {
    /**
     * @param customTabButtons ...
     * @throws Error if customTabButtons has more than 5 items.
     */
    static getNumberOfCustomTabsToShow(customTabButtons) {
        const buttons = customTabButtons?.length ?? 0;
        if (buttons > 5) {
            console.error('Maximum five custom tabs are allowed');
            return 5;
        }
        return buttons;
    }
    static getCustomTabSlots(numberOfCustomTabs) {
        const slots = [];
        for (let n = 1; n <= numberOfCustomTabs; n++) {
            slots.push(html `<slot slot="custom-tab-${n}" name="custom-tab-${n}"></slot>`);
        }
        return slots;
    }
}
//# sourceMappingURL=SummaryPageCustomTabsUtility.js.map